// Per-org overlay on the single global managed Formant chat agent
// (`agt_formant_chat`, WS-C). The base agent stays tenant-agnostic and
// read-only (managed row, 403 on CRUD); this row lets an org shape its
// assistant — prompt append, model, which MCP connections, default thinking —
// applied by the persistent-agent host at the CHAT build. One row per org;
// every field optional (absent ⇒ the managed default).
import { z } from 'zod';
export const OrgChatConfigSchema = z.object({
    orgId: z.string(),
    /** Appended AFTER the base system prompt (never replaces it); null = none. */
    systemPromptAppend: z.string().nullable(),
    /** Per-org chat model override; null = the managed default (mc_system_chat). */
    modelConfigId: z.string().nullable(),
    /**
     * Connection ids the chat agent may NOT use. Chat unions ALL of the org's
     * live connections by default; these are removed from that union. Empty = no
     * restriction (a connection added later is included automatically).
     */
    disabledMcpConnectionIds: z.array(z.string()),
    /** Tool names withheld from the chat agent's resolved tool set (by exact name). */
    toolDenylist: z.array(z.string()),
    /** Default extended-thinking toggle for chat turns; null = model default. */
    defaultThinking: z.boolean().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
/**
 * Body for `PUT /v1/org-chat-config` — upsert this org's overlay. All fields
 * optional (a PUT may set any subset); omitting a field leaves it unchanged.
 * `null` clears a field back to the managed default. `disabledMcpConnectionIds`
 * has no null (an empty array is the "no restriction" state).
 */
export const UpdateOrgChatConfigInputSchema = z
    .object({
    systemPromptAppend: z.string().max(8000).nullable().optional(),
    modelConfigId: z.string().min(1).nullable().optional(),
    disabledMcpConnectionIds: z.array(z.string().min(1)).max(200).optional(),
    toolDenylist: z.array(z.string().min(1)).max(500).optional(),
    defaultThinking: z.boolean().nullable().optional(),
})
    .strict();
//# sourceMappingURL=org-chat-config.js.map